import { render, staticRenderFns } from "./DialogAuthentication.vue?vue&type=template&id=53be15dc&scoped=true"
import script from "./DialogAuthentication.vue?vue&type=script&lang=js"
export * from "./DialogAuthentication.vue?vue&type=script&lang=js"
import style0 from "./DialogAuthentication.vue?vue&type=style&index=0&id=53be15dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___2141a494b913d03a9170cbed536032b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be15dc",
  null
  
)

export default component.exports